var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [this.$slots['default'] ? _c('h5', {
    staticClass: "tit tit--sm d-flex align-center"
  }, [_c('v-img', {
    staticClass: "mr-4px mr-md-8px",
    attrs: {
      "max-width": "30",
      "aspect-ratio": 30 / 24,
      "src": "/images/icon/icon-sprout.svg"
    }
  }), _vm._t("default")], 2) : _vm._e(), this.$slots['text'] ? _c('div', {
    staticClass: "txt txt--xl txt--dark"
  }, [_vm._t("text")], 2) : _vm._e(), _c('v-divider', {
    staticClass: "grey lighten-2 my-16px my-md-24px"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }